function check_mask(value, mask) {

  var strName,
    strMask,
    intIdx,
    strValue,
    obj,
    strRegExp,
    i,
    regExp,
    aResults,
    compare;
  var blnInLiteral, chrMask;
  strMask = mask;
  blnInLiteral = false;
  strValue = value == null ? "" : String(value);

  if (strMask == "") {
    return { isValid: true, formattedValue: strValue };
  }
  var strMaskForDecimal = strMask.replace(/"/g, "");
  strRegExp = "^9+\\.0+$";

  regExp = new RegExp(strRegExp, "");
  if (regExp.test(strMaskForDecimal)) {
    var nRequiredDecmalCount, nActualDecimalCount;

    nRequiredDecmalCount =
      strMaskForDecimal.length - strMaskForDecimal.indexOf(".") - 1;

    if (strValue.indexOf(".") < 0) strValue += ".";

    nActualDecimalCount = strValue.length - strValue.indexOf(".") - 1;

    if (nRequiredDecmalCount > nActualDecimalCount) {
      var nTargetLength = strValue.indexOf(".") + nRequiredDecmalCount + 1;
      strValue = strValue.padEnd(nTargetLength, "0");
    }
  }

  strRegExp = "^";

  for (i = 0; i < strMask.length; i++) {
    chrMask = strMask.charAt(i);
    if (blnInLiteral) {
      if (chrMask == '"') {
        if (i < strMask.length - 1 && strMask.charAt(i + 1) == '"') {
          strRegExp += chrMask;
          i = i + 1;
        } else blnInLiteral = false;
      } else {
        if (chrMask.charCodeAt(0) < 48 || chrMask.charCodeAt(0) > 57) {
          if (chrMask.toLowerCase() < "a" || chrMask.toLowerCase() > "z")
            strRegExp += "\\";
        }

        strRegExp += chrMask;
      }
    } else {
      switch (chrMask) {
        case "0":
          if (i == strMask.length - 1) strRegExp += "(\\d$)";
          else strRegExp += "(\\d)";
          break;
        case "9":
          if (i == strMask.length - 1) strRegExp += "(\\d$)";
          else strRegExp += "(\\d?)";

          break;

        case "L":
          strRegExp += "([a-z])";
          break;
        case "l":
          strRegExp += "([a-z]?)";
          break;
        case "A":
          strRegExp += "([a-z0-9])";
          break;
        case "a":
          strRegExp += "([a-z0-9]?)";
          break;
        case ".":
          strRegExp += "(.)";
          break;
        case "#":
          strRegExp += "(.?)";
          break;
        case '"':
          blnInLiteral = true;
          break;
        case "-":
          strRegExp += "(-)";
          break;
      }
    }
  }

  if (!check_mask_type(strMask)) strRegExp += "\\b";

  regExp = new RegExp(strRegExp, "i");
  var returnval = regExp.test(strValue);
  return { isValid: returnval, formattedValue: strValue };
}
function check_mask_type(strMaskType) {
  var blnFlag = false;
  var i = 0;
  for (i = 0; i < strMaskType.length; i++) {
    if (strMaskType.charAt(i) == "#") {
      blnFlag = true;
    } else {
      blnFlag = false;
      return blnFlag;
    }
  }
  return blnFlag;
}
export default check_mask;
